import * as type from './type';
import util from 'common/js/util';

export default{
    [type.GET_PRODUCT_LINE_LIST](context, option){
        util.post({
            params: {
                functionId: 'getAllProductLine',
                body: JSON.stringify(option.params)
            },
            sc(data){
                if(option && option.sc){
                    option.sc && option.sc(data);
                }
            },
            fc(data){
                if(option && option.fc){
                    option.fc && option.fc(data);
                }
            }
        });
    },
    [type.GET_PLINE_PRODUCT](context, option){
        util.post({
            params: {
                functionId: 'getOneProductLine',
                body: JSON.stringify(option.params)
            },
            sc(data){
                if(option && option.sc){
                    option.sc && option.sc(data);
                }
            },
            fc(data){
                if(option && option.fc){
                    option.fc && option.fc(data);
                }
            }
        });
    },
}



// WEBPACK FOOTER //
// ./src/store/product-line/actions.js